import $ from 'jquery';
import 'readmore-js';

const toggleText = () => {
  $('.js-toggle-text').readmore({
    collapsedHeight: 100,
    beforeToggle: (trigger, element) => {
      element.toggleClass('active');
    },
  });
};
export default toggleText;



// WEBPACK FOOTER //
// ./src/scripts/modules/toggle-text.js